import { SynchronizedType } from '../../../../order.types';
import {
  ForceSyncOrderStatusRule,
  IForceSyncOrderStatusRule,
} from '../force-sync-order-status-rule.interface';

export class SentForceSyncRule implements IForceSyncOrderStatusRule {
  showForceSync({ orderStatusSync, triggerIntegrationConfig }: ForceSyncOrderStatusRule): boolean {
    const availableForSync =
      orderStatusSync &&
      [
        SynchronizedType.ERROR,
        SynchronizedType.NOT_SYNCHRONIZED,
        SynchronizedType.SUCCESS_WITH_PAYMENT_ERROR,
      ].includes(orderStatusSync);

    if (!availableForSync || !triggerIntegrationConfig) {
      return false;
    }

    return true;
  }
}
